export default "__VITE_ASSET__C$FxAWxl__"